// extracted by mini-css-extract-plugin
export default {"error":"PortalPage__error--1dl","content":"PortalPage__content--38I"};